var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group__wrapper",class:{ error: _vm.error }},[_vm._t("default",null,{"id":_vm.id,"hasError":!!_vm.error}),(_vm.error && _vm.errorMessage)?[_c('div',{staticClass:"invalid-message"},[_vm._v(" "+_vm._s(_vm.errorMessage)+" ")])]:_vm._e(),_vm._t("after")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }